import { useState, useEffect } from 'react';
import { useApi } from './use-api';
import { DynamicLink } from '../api-service/clients/auto-generated-clients';
import { moduleClientFactory } from '../api-service/module-client-factory';
import { dynamicLinksDataMerge } from '../utilities';

export function useDynamicLinks(resourceType: string, id: string) {
  const [dynamicLinks, setDynamicLinks] = useState<DynamicLink[] | undefined>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const client = moduleClientFactory.createDynamicLinkClient();
  const api = useApi(cancelToken => client.getDynamicLinks({ resourceType, resourceId: id }, cancelToken), { dynamicLinks: [], mergeData: [] });

  useEffect(() => {
    setLoading(true);
    api
      .invoke()
      .then(x => {
        const links = dynamicLinksDataMerge(x.result.dynamicLinks, x.result.mergeData);
        setDynamicLinks(links);
      })
      .catch(err => setError(err))
      .finally(() => setLoading(false));

    // eslint-disable-next-line
  }, [resourceType, id]);

  return { dynamicLinks, loading, error };
}
